import { TitleCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { UserRoleRepresentationDto } from '@workspace/data-types';

@Component({
  selector: 'core-user-roles-display',
  templateUrl: './roles-display.component.html',
  standalone: true,
  imports: [TitleCasePipe],
})
export class UserRolesDisplayAdminCoreComponent {
  currentRoles = input<UserRoleRepresentationDto[]>([]);
}
